<template>
  <div class="wg-attachments">
    <div class="wg-head">
      <h4>ATTACHMENTS</h4>
      <a v-if="0" href="javascript:;" class="btn btn-outline-gray">+</a>
    </div>
    <div class="wg-body">
      <ul v-if="ATTACHMENTS.length">
        <li v-for="(item, index) in ATTACHMENTS" :key="index">
          <a target="_blank" :href="item.download_url">{{ item.name }}</a>
          <br/>
          <span class="small"><a href="javascript:;" style="text-decoration: none;" class="text-danger" @click="confDelete(index)"> Delete</a></span>
        </li>
      </ul>
      <h5 v-else>No attachments.</h5>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ServiceJob from '@/services/job'

export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['JOB', 'ATTACHMENTS'])
  },
  created () {},
  mounted () {},
  methods: {
    init () {},
    confDelete ( index ) {
      let self = this, item = self.ATTACHMENTS[index];
      self.$dialog
        .confirm('Are you sure you want to delete attachment <strong>' + item.name + '</strong>?', {
          html: true,
          loader: true,
          okText: "Yes, I'm sure",
          cancelText: "Cancel",
        })
        .then(dialog => {
          ServiceJob.deleteAttachment(self.JOB.id, item.id, () => {
            dialog.close();
            self.$notify({
              type: 'success',
              text: 'Attachment <strong>' + item.name + '</strong> has been deleted'
            });
            self.$store.dispatch('GET_JOB', self.JOB.id);
          });
        })
        .catch(() => {})
      ;
    }
  }
}
</script>
